import { PublicEventType } from '../../enums';
import { PublicEventPayloadValidator } from '../../types';
import { PublicAddToCartResponsePayload } from './types';

export const publicAddToCartResponsePayloadValidator: PublicEventPayloadValidator<
  PublicEventType.AddToCartResponse
> = (payload: unknown): payload is PublicAddToCartResponsePayload =>
  !!payload &&
  typeof payload === 'object' &&
  'success' in payload &&
  typeof payload.success === 'boolean' &&
  (payload.success
    ? 'cartUrl' in payload
      ? typeof payload.cartUrl === 'string' ||
        typeof payload.cartUrl === 'undefined'
      : true
    : 'error' in payload
      ? typeof payload.error === 'string' ||
        typeof payload.error === 'undefined'
      : true);
